/* eslint-disable */
import { useState, FormEvent } from "react";
import "../../styles/ContactPage.css";
import contacto from "../../assets/titulos/contacto.png";
import contact from "../../assets/titles/contact.png";

import emailjs from "emailjs-com";
import { useTranslation } from "react-i18next";
import LocalizedTitleImage from "../../components/UseLanguage";
import menuIcon from "../../assets/menu.png";

const SERVICE_ID = "service_gyck0t5";
const TEMPLATE_ID = "template_2bv4h61";
const PUBLIC_KEY = "zFzjhYgAO-VTRca_E";

const ContactPage: React.FC = () => {
  const [nombre, setNombre] = useState("");
  const [email, setEmail] = useState("");
  const [mensaje, setMensaje] = useState("");
  const [enviado, setEnviado] = useState(false);

  const [enviando, setEnviando] = useState(false);

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (enviando) return;

    setEnviando(true);

    const templateParams = {
      from_name: nombre,
      from_email: email,
      message: mensaje,
    };

    try {
      await emailjs.send(SERVICE_ID, TEMPLATE_ID, templateParams, PUBLIC_KEY);
      setEnviado(true);
      setNombre("");
      setEmail("");
      setMensaje("");
    } catch (error) {
      console.error("Error al enviar el mensaje:", error);
      alert("Hubo un error al enviar el mensaje");
    } finally {
      setEnviando(false);
    }
  };
  const { t } = useTranslation();

  return (
    <div>
      <div className="menu-icon-divc">
        <img src={menuIcon} />
      </div>
      <div className="contact-page fade-tab">
        <div className="contacto-title-wrapper">
          <LocalizedTitleImage
            imageEn={contact}
            imageEs={contacto}
            className="contacto-title-img"
          />
        </div>

        {enviado ? (
          <p className="success-message">{t("contacto.form.exito")}</p>
        ) : (
          <form className="contact-form" onSubmit={handleSubmit}>
            <label>
              {t("contacto.form.nombre")}:
              <input
                type="text"
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
                required
              />
            </label>
            <label>
              {t("contacto.form.email")}:
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </label>
            <label>
              {t("contacto.form.mensaje")}:
              <textarea
                value={mensaje}
                onChange={(e) => setMensaje(e.target.value)}
                required
              />
            </label>
            <button type="submit">{t("contacto.form.enviar")}</button>
          </form>
        )}
      </div>
    </div>
  );
};

export default ContactPage;
